/* eslint-disable no-useless-constructor */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Text extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const contentVal = content.data.replace(/<p[\S ]*?>([\S ]*?)<\/p>/gi, '$1');

        return <p dangerouslySetInnerHTML={{ __html: contentVal }} />;
    }
}

export default errorBoundary(Text);
